import DiagnosticContainer from './DiagnosticContainer';
export default DiagnosticContainer;
